import React from 'react';
import MovingText from 'react-moving-text'
// import styled from 'styled-components';

// const HeroWrapper = styled.div`
// height: 80vh;
// width: 100%;
// `
// const HeroBg = styled.div`
// /* background-image: url(../images/handybg.webp); */
// background-color: black;
// height: 100%;
// `
// const HeroHeading = styled.h1`
// font-size: 1rem;
// color: white;
// text-align: center;
// justify-content: center;
// align-items: center;
// `
// const HeroText = styled.p`
// color: white;
// text-align: center;
// justify-content: center;
// align-items: center;
// size: 1rem;
// `

// const Hero = () => {
//   return (
//     <HeroWrapper>
//         <HeroBg>
//             <HeroHeading>Neil The Handy Man</HeroHeading>
//             <HeroText>Fellow Handy Man</HeroText>
//         </HeroBg>
//     </HeroWrapper>
//   )
// }

// export default Hero


const Hero = () => {
  return (
    <>
    <div className="HeroWrapper">
      <div className="HeroBg">
        <h1 className="HeroHeading">Neil The <span><MovingText type="typewriter"
  dataText={[
  'Great',
  'Fantastic',
  'Incredible',
  'Efficient'
]} /></span>Handy Man </h1>
          <p className="HeroText"><span><MovingText
  type="pulse"
  duration="2000ms"
  delay="2s"
  direction="normal"
  timing="ease-out"
  iteration="infinite"
  fillMode="none">
  Neils Work is Good Work
</MovingText></span></p>
      </div>
    </div>
    </>
  )
}

export default Hero